<template>
    <div class="flex flex-row gap-4 items-center text-5xl">
        <TacticIcon class="size-12 text-gray-700" />
        <span class="font-light text-gray-500">{{ $t('no-scenario-loaded') }}</span>
    </div>
</template>

<script setup lang="ts">
import TacticIcon from '../Icon/TacticIcon.vue';
</script>
